module.exports = __webpack_public_path__ + "static/media/logo-correios-menu.50250061.svg";